<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <RefundsTabs></RefundsTabs>
        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :title="`${$t('pages.ref_return')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import API from '@/api/API'
  import Storage from '@/api/Storage'
  import { map } from 'lodash'
  import Helper from '@/api/Helper'
  import TypeColor from '@/assets/TypeColor'
  import StatisticTable from '@/components/StatisticTable.vue'
  import RefundsTabs from './RefundsTabs.vue'

  export default {
    name: 'Buyout',
    components: {
      Filters,
      StatisticTable,
      RefundsTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          courierFilter: true,
          byWmFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.refunds_id'), field: 'refunds_id'},
          {label: this.$root.$t('statistic.return_title'), field: 'return_title'},
          {label: this.$root.$t('statistic.return_count'), field: 'return_count', colspan: 2}
        ],
        rows: [],
        footColumns: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        API.getRefundsStatistic(2).then(response => {
          let reasons = {}
          let total = 0
          map(response.body, d => {
            if (!reasons[d.reason_id]) {
              reasons[d.reason_id] = d
            } else {
              reasons[d.reason_id].count += d.count
            }
            total += d.count
          })
          map(reasons, (d) => {
            this.rows.push({
              reason_id: {value: d.reason_id, style: {textAlign: 'left'}},
              reason: {value: d.reason_text, style: {textAlign: 'left'}},
              count: {
                value: d.count,
                bgg: Helper.renderGistPart(total, d.count),
                isCollspaned: true
              },
              countPercents: {
                value: Helper.percents(total, d.count),
                bgg: Helper.renderGistPart(total, d.count, true)
              }
            })
          })
          this.footColumns = {
            label_id: {
              value: this.$root.$t('')
            },
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            count: {
              value: `${total} (${Helper.average(total, 1)})`
            },
            countPercents: {
              value: Helper.percents(total, total)
            }
          }
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Return.vue?dcf41830